class SessionHelper {
  constructor() {
    this.TOKEN_KEY = 'token'
    this.ROLE_KEY = 'role'
    this.FULLNAME_KEY = 'fullName'
  }

  get token() {
    return localStorage.getItem(this.TOKEN_KEY)
  }

  set token(value) {
    localStorage.setItem(this.TOKEN_KEY, value)
  }

  get role() {
    return localStorage.getItem(this.ROLE_KEY)
  }

  set role(value) {
    localStorage.setItem(this.ROLE_KEY, value)
  }

  get fullName() {
    return localStorage.getItem(this.FULLNAME_KEY)
  }

  set fullName(value) {
    localStorage.setItem(this.FULLNAME_KEY, value)
  }

  update(user) {
    localStorage.setItem(this.TOKEN_KEY, user.token)
    localStorage.setItem(this.ROLE_KEY, user.role)
    localStorage.setItem(this.FULLNAME_KEY, user.fullName)
  }

  clear() {
    localStorage.removeItem(this.TOKEN_KEY)
    localStorage.removeItem(this.ROLE_KEY)
    localStorage.removeItem(this.FULLNAME_KEY)
  }
}
export default new SessionHelper()
